module.exports = __webpack_public_path__ + "img/gccc-banner.58f47526.jpg";